/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {BackRewardsCoinBankStatusEnum} from './enum'

interface InitialStateType {
  isSupportApng: boolean // 是否支持apng
  is_newer?: boolean
  is_call_homepage?: boolean
  coin_bank?: {
    countdown: number
    end_time_str: string
    up: number
    bet_coin: number
    target_bet_coin: number
    round_cnt: number
    target_round_cnt: number
    status: BackRewardsCoinBankStatusEnum
  }
}

export const newer_subsidy_homepage = createAsyncThunk(
  'newer_subsidy_homepage',
  async (arg, store: any) => {
    // return {
    //   is_newer: true,
    //   is_call_homepage: true,
    //   coin_bank: {
    //     countdown: 17262,
    //     up: 1276182,
    //     bet_coin: 12,
    //     target_bet_coin: 100,
    //     round_cnt: 10,
    //     target_round_cnt: 10,
    //     status: 2, // 2可领奖  1进行中
    //   },
    // }
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/newer_subsidy_homepage',
      {
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export const newer_subsidy_result = createAsyncThunk(
  'newer_subsidy_result',
  async (arg, store: any) => {
    // return {
    //   is_newer: true,
    //   coin_bank: {
    //     countdown: 1726,
    //     up: 1276182,
    //     bet_coin: 12,
    //     target_bet_coin: 100,
    //     round_cnt: 10,
    //     target_round_cnt: 10,
    //     status: 2, // 2可领奖  1进行中
    //   },
    //   reward: {
    //     url: '',
    //     name: '',
    //     coin: 1000,
    //   },
    //   subsidy_type: 1, // 1. 输钱   2 首次赢钱   3 非首次赢钱
    // }
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/game/newer_subsidy_result',
      {
        ...deviceinfo,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

const initialState: InitialStateType = {
  isSupportApng: false,
}

export const backRewardsSlice = createSlice({
  name: 'backRewards',
  initialState,
  reducers: {
    updateIsSupportApng: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {isSupportApng: action.payload})
    },
    updateBackRewards: (state, action: PayloadAction<any>) => {
      Object.assign(state, action.payload)
    },
    resetCoinBankCountDown: (state) => {
      const {coin_bank} = state
      Object.assign(state, {
        coin_bank: {
          ...coin_bank,
          countdown: 0,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newer_subsidy_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(newer_subsidy_result.fulfilled, (state, action) => {
      const {coin_bank, is_newer} = action.payload
      Object.assign(state, {
        coin_bank,
        is_newer,
      })
    })
  },
})

export function useBackRewards() {
  return useSelector((store) => store.Animal_Seal)
}

export default backRewardsSlice.reducer
export const backRewardsActions = backRewardsSlice.actions
